// extracted by mini-css-extract-plugin
module.exports = {"root":"input_root__1mdlT"};